export const extractGoogleDriveFileId = (inputUrl?: string | null): string | undefined => {
  if (!inputUrl) return undefined;

  const trimmedUrl = inputUrl.trim();
  if (!trimmedUrl) return undefined;

  const ensureProtocol = (url: string) => {
    if (/^https?:\/\//i.test(url)) {
      return url;
    }
    return `https://${url}`;
  };

  const URL_PATTERNS = [
    /\/d\/([a-zA-Z0-9_-]{10,})/,
    /\/d\/e\/([a-zA-Z0-9_-]{10,})/,
    /\/file\/d\/([a-zA-Z0-9_-]{10,})/,
    /\/folders\/([a-zA-Z0-9_-]{10,})/,
  ];

  const queryParamKeys = ['id', 'resourcekey'];

  const attemptParse = (candidate: string): string | undefined => {
    try {
      const parsedUrl = new URL(ensureProtocol(candidate));

      for (const key of queryParamKeys) {
        const paramValue = parsedUrl.searchParams.get(key);
        if (paramValue && /[a-zA-Z0-9_-]{10,}/.test(paramValue)) {
          return paramValue;
        }
      }

      const normalisedPath = parsedUrl.pathname;
      for (const pattern of URL_PATTERNS) {
        const match = normalisedPath.match(pattern);
        if (match && match[1]) {
          return match[1];
        }
      }
    } catch (error) {
      // Ignore and fall through to secondary parsing
    }
    return undefined;
  };

  const directMatch = attemptParse(trimmedUrl);
  if (directMatch) {
    return directMatch;
  }

  // Secondary check for raw IDs in the string (e.g. copied without protocol)
  const FALLBACK_PATTERN = /(?:id=)?([a-zA-Z0-9_-]{10,})/;
  const fallbackMatch = trimmedUrl.match(FALLBACK_PATTERN);
  return fallbackMatch && fallbackMatch[1] ? fallbackMatch[1] : undefined;
};
